// src/components/marketing/GoogleReviews.jsx
// Elfsight Google Reviews widget (embed code supplied by Claire, Aug 2026).
//
// This replaces a hand-built reviews section that had six reviews hardcoded in
// the source — those were a snapshot that would silently go stale and never
// show a new review. Elfsight pulls live from the Google listing.
//
// Elfsight's platform.js scans for .elfsight-app-* containers on load, so the
// script is injected once and reused across mounts rather than re-added on
// every navigation.

import { useEffect } from 'react';

const SCRIPT_SRC = 'https://elfsightcdn.com/platform.js';
const APP_CLASS = 'elfsight-app-f59da91f-9915-4317-83e8-da1be5e43914';

export default function GoogleReviews() {
  useEffect(() => {
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
      // Already loaded on an earlier page — ask it to pick up this container.
      window.eapps?.initWidgetsFromBuffer?.();
      return;
    }
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section style={{ background: '#fff', padding: '80px 4%' }}>
      <div style={{ maxWidth: '1240px', margin: '0 auto' }}>
        <div className={APP_CLASS} data-elfsight-app-lazy />
      </div>
    </section>
  );
}
